import React from 'react'

import { Switch, Redirect, Route } from 'react-router-dom'
import { include, reverse } from 'named-urls'

import { SupplierRouteWithLayout } from './components'

import { SuppliersJourneyLayout, SuppliersMainLayout } from './layouts'

import Forbidden from 'views/Forbidden'
import NotFound from 'views/NotFound'

import Journey from 'views/Suppliers/Journey'
import Home from 'views/Suppliers/Home'
import QuizQuestionTemplateNew from 'views/Suppliers/QuizQuestionTemplateNew'
import QuizQuestionTemplateEdit from 'views/Suppliers/QuizQuestionTemplateEdit'

import ClientPortalThemeProvider from 'providers/ClientPortalThemeProvider'

import useAuthSupplier from 'hooks/useAuthSupplier'

import constants from 'constants/index'

const Routes = () => {
  return (
    <Switch>
      <SupplierRouteWithLayout
        path={routes.home}
        component={Home}
        layout={SuppliersMainLayout}
        exact
        auth
      />
      <SupplierRouteWithLayout
        path={routes.quizQuestionTemplate.new}
        component={QuizQuestionTemplateNew}
        layout={SuppliersMainLayout}
        exact
        auth
      />
      <SupplierRouteWithLayout
        path={routes.quizQuestionTemplate.edit}
        component={QuizQuestionTemplateEdit}
        layout={SuppliersMainLayout}
        exact
        auth
      />

      {/* Para novas rotas criar acima ↑*/}
      {/* Rotas sem autenticação */}
      <SupplierRouteWithLayout
        path={routes.journey}
        component={Journey}
        layout={SuppliersJourneyLayout}
        provider={ClientPortalThemeProvider}
        exact
      />
      <Route
        exact
        path="/suppliers/:token/journey"
        render={({ match }) => (
          <Redirect
            to={reverse(routes.journey, {
              slug: constants.settings.PLATFORM_SLUG_ID,
              token: match.params.token,
            })}
          />
        )}
      />
      {/* Formatos legados → jornada nova (token antigo cai em link inválido) */}
      <Route
        exact
        path="/suppliers/:slug/journey/:token"
        render={({ match }) => (
          <Redirect
            to={reverse(routes.journey, {
              slug: match.params.slug,
              token: match.params.token,
            })}
          />
        )}
      />
      <Route
        exact
        path="/suppliers/journey/:token"
        render={({ match }) => (
          <Redirect
            to={reverse(routes.journey, {
              slug: constants.settings.PLATFORM_SLUG_ID,
              token: match.params.token,
            })}
          />
        )}
      />
      <Route
        render={() => <NotFound useAuthHook={useAuthSupplier} />}
        exact
        path={routes.notFound}
      />
      <Route component={Forbidden} exact path={routes.forbidden} />
      <Redirect to={routes.notFound} />
    </Switch>
  )
}

export const routes = {
  root: '/:slug?/',

  notFound: '/suppliers/not-found',
  forbidden: '/suppliers/forbidden',

  journey: '/:slug/suppliers/:token/journey',

  home: '/suppliers/home',
  quizQuestionTemplate: include(
    '/suppliers/companySupplierQuestionnaires/:companySupplierQuestionnaireId/quizQuestionTemplates/:quizQuestionTemplateId',
    {
      new: 'new',
      edit: 'edit',
    },
  ),
}

export default Routes
